// extracted by mini-css-extract-plugin
module.exports = {"laneStyle":"KanbanView_laneStyle__2odRb"};